// Dev mock — MUST BE REMOVED once real integration ships `type`/min/max/avg data.
// Covers all 4 dev-mock types (feed-in, feed-out, ht, nt) that ecp-settings'
// DEV_MOCK_SUPPORTED_TYPES advertises, so any Display Types selection in Portal
// Builder preview renders data. Lowercase to match ecp-settings values.
// min/max/avg are attached to the ht entries (pivot takes the first defined
// value per timestamp) so the overlay demo works regardless of type selection.

export const MOCK_CONSUMPTIONS: {
  consumptions: {
    timestamp: string
    value: number
    type?: string
    min?: number
    max?: number
    avg?: number
  }[]
} = {
  consumptions: [
    // ht (peak tariff) — carries per-timestamp min/max/avg metrics
    {
      timestamp: '2025-03-04T22:00:00.000Z',
      value: 0.05,
      type: 'ht',
      min: 0.05,
      max: 0.14,
      avg: 0.09
    },
    {
      timestamp: '2025-03-04T23:00:00.000Z',
      value: 0.02,
      type: 'ht',
      min: 0.02,
      max: 0.06,
      avg: 0.04
    },
    {
      timestamp: '2025-03-05T00:00:00.000Z',
      value: 0.02,
      type: 'ht',
      min: 0.03,
      max: 0.08,
      avg: 0.05
    },
    {
      timestamp: '2025-03-05T01:00:00.000Z',
      value: 0.02,
      type: 'ht',
      min: 0.03,
      max: 0.1,
      avg: 0.06
    },
    {
      timestamp: '2025-03-05T02:00:00.000Z',
      value: 0.02,
      type: 'ht',
      min: 0.03,
      max: 0.1,
      avg: 0.06
    },
    {
      timestamp: '2025-03-05T03:00:00.000Z',
      value: 0.03,
      type: 'ht',
      min: 0.04,
      max: 0.12,
      avg: 0.07
    },
    {
      timestamp: '2025-03-05T04:00:00.000Z',
      value: 0.03,
      type: 'ht',
      min: 0.04,
      max: 0.12,
      avg: 0.07
    },
    {
      timestamp: '2025-03-05T05:00:00.000Z',
      value: 0.08,
      type: 'ht',
      min: 0.08,
      max: 0.22,
      avg: 0.14
    },
    {
      timestamp: '2025-03-05T06:00:00.000Z',
      value: 0.1,
      type: 'ht',
      min: 0.1,
      max: 0.24,
      avg: 0.16
    },
    {
      timestamp: '2025-03-05T07:00:00.000Z',
      value: 0.12,
      type: 'ht',
      min: 0.12,
      max: 0.28,
      avg: 0.18
    },
    {
      timestamp: '2025-03-05T08:00:00.000Z',
      value: 0.13,
      type: 'ht',
      min: 0.12,
      max: 0.3,
      avg: 0.19
    },
    {
      timestamp: '2025-03-05T09:00:00.000Z',
      value: 0.14,
      type: 'ht',
      min: 0.13,
      max: 0.32,
      avg: 0.2
    },
    {
      timestamp: '2025-03-05T10:00:00.000Z',
      value: 0.15,
      type: 'ht',
      min: 0.14,
      max: 0.34,
      avg: 0.22
    },
    {
      timestamp: '2025-03-05T11:00:00.000Z',
      value: 0.09,
      type: 'ht',
      min: 0.08,
      max: 0.22,
      avg: 0.14
    },
    {
      timestamp: '2025-03-05T12:00:00.000Z',
      value: 0.1,
      type: 'ht',
      min: 0.09,
      max: 0.24,
      avg: 0.15
    },
    {
      timestamp: '2025-03-05T13:00:00.000Z',
      value: 0.1,
      type: 'ht',
      min: 0.1,
      max: 0.24,
      avg: 0.16
    },
    {
      timestamp: '2025-03-05T14:00:00.000Z',
      value: 0.11,
      type: 'ht',
      min: 0.1,
      max: 0.26,
      avg: 0.17
    },
    {
      timestamp: '2025-03-05T15:00:00.000Z',
      value: 0.12,
      type: 'ht',
      min: 0.12,
      max: 0.26,
      avg: 0.18
    },
    {
      timestamp: '2025-03-05T16:00:00.000Z',
      value: 0.25,
      type: 'ht',
      min: 0.24,
      max: 0.58,
      avg: 0.4
    },
    {
      timestamp: '2025-03-05T17:00:00.000Z',
      value: 0.28,
      type: 'ht',
      min: 0.26,
      max: 0.6,
      avg: 0.42
    },
    {
      timestamp: '2025-03-05T18:00:00.000Z',
      value: 0.3,
      type: 'ht',
      min: 0.28,
      max: 0.62,
      avg: 0.44
    },
    {
      timestamp: '2025-03-05T19:00:00.000Z',
      value: 0.32,
      type: 'ht',
      min: 0.28,
      max: 0.66,
      avg: 0.46
    },
    {
      timestamp: '2025-03-05T20:00:00.000Z',
      value: 0.34,
      type: 'ht',
      min: 0.3,
      max: 0.68,
      avg: 0.48
    },
    {
      timestamp: '2025-03-05T21:00:00.000Z',
      value: 0.18,
      type: 'ht',
      min: 0.18,
      max: 0.4,
      avg: 0.27
    },

    // nt (off-peak tariff)
    { timestamp: '2025-03-04T22:00:00.000Z', value: 0.04, type: 'nt' },
    { timestamp: '2025-03-04T23:00:00.000Z', value: 0.02, type: 'nt' },
    { timestamp: '2025-03-05T00:00:00.000Z', value: 0.03, type: 'nt' },
    { timestamp: '2025-03-05T01:00:00.000Z', value: 0.04, type: 'nt' },
    { timestamp: '2025-03-05T02:00:00.000Z', value: 0.04, type: 'nt' },
    { timestamp: '2025-03-05T03:00:00.000Z', value: 0.04, type: 'nt' },
    { timestamp: '2025-03-05T04:00:00.000Z', value: 0.04, type: 'nt' },
    { timestamp: '2025-03-05T05:00:00.000Z', value: 0.06, type: 'nt' },
    { timestamp: '2025-03-05T06:00:00.000Z', value: 0.06, type: 'nt' },
    { timestamp: '2025-03-05T07:00:00.000Z', value: 0.06, type: 'nt' },
    { timestamp: '2025-03-05T08:00:00.000Z', value: 0.06, type: 'nt' },
    { timestamp: '2025-03-05T09:00:00.000Z', value: 0.06, type: 'nt' },
    { timestamp: '2025-03-05T10:00:00.000Z', value: 0.07, type: 'nt' },
    { timestamp: '2025-03-05T11:00:00.000Z', value: 0.05, type: 'nt' },
    { timestamp: '2025-03-05T12:00:00.000Z', value: 0.05, type: 'nt' },
    { timestamp: '2025-03-05T13:00:00.000Z', value: 0.06, type: 'nt' },
    { timestamp: '2025-03-05T14:00:00.000Z', value: 0.06, type: 'nt' },
    { timestamp: '2025-03-05T15:00:00.000Z', value: 0.06, type: 'nt' },
    { timestamp: '2025-03-05T16:00:00.000Z', value: 0.15, type: 'nt' },
    { timestamp: '2025-03-05T17:00:00.000Z', value: 0.14, type: 'nt' },
    { timestamp: '2025-03-05T18:00:00.000Z', value: 0.14, type: 'nt' },
    { timestamp: '2025-03-05T19:00:00.000Z', value: 0.14, type: 'nt' },
    { timestamp: '2025-03-05T20:00:00.000Z', value: 0.14, type: 'nt' },
    { timestamp: '2025-03-05T21:00:00.000Z', value: 0.09, type: 'nt' },

    // feed-in (grid consumption — prosumer drawing from grid at night/evening)
    { timestamp: '2025-03-04T22:00:00.000Z', value: 0.12, type: 'feed-in' },
    { timestamp: '2025-03-04T23:00:00.000Z', value: 0.1, type: 'feed-in' },
    { timestamp: '2025-03-05T00:00:00.000Z', value: 0.09, type: 'feed-in' },
    { timestamp: '2025-03-05T01:00:00.000Z', value: 0.08, type: 'feed-in' },
    { timestamp: '2025-03-05T02:00:00.000Z', value: 0.08, type: 'feed-in' },
    { timestamp: '2025-03-05T03:00:00.000Z', value: 0.08, type: 'feed-in' },
    { timestamp: '2025-03-05T04:00:00.000Z', value: 0.08, type: 'feed-in' },
    { timestamp: '2025-03-05T05:00:00.000Z', value: 0.1, type: 'feed-in' },
    { timestamp: '2025-03-05T06:00:00.000Z', value: 0.14, type: 'feed-in' },
    { timestamp: '2025-03-05T07:00:00.000Z', value: 0.16, type: 'feed-in' },
    { timestamp: '2025-03-05T08:00:00.000Z', value: 0.12, type: 'feed-in' },
    { timestamp: '2025-03-05T09:00:00.000Z', value: 0.08, type: 'feed-in' },
    { timestamp: '2025-03-05T10:00:00.000Z', value: 0.05, type: 'feed-in' },
    { timestamp: '2025-03-05T11:00:00.000Z', value: 0.03, type: 'feed-in' },
    { timestamp: '2025-03-05T12:00:00.000Z', value: 0.02, type: 'feed-in' },
    { timestamp: '2025-03-05T13:00:00.000Z', value: 0.02, type: 'feed-in' },
    { timestamp: '2025-03-05T14:00:00.000Z', value: 0.03, type: 'feed-in' },
    { timestamp: '2025-03-05T15:00:00.000Z', value: 0.05, type: 'feed-in' },
    { timestamp: '2025-03-05T16:00:00.000Z', value: 0.1, type: 'feed-in' },
    { timestamp: '2025-03-05T17:00:00.000Z', value: 0.2, type: 'feed-in' },
    { timestamp: '2025-03-05T18:00:00.000Z', value: 0.3, type: 'feed-in' },
    { timestamp: '2025-03-05T19:00:00.000Z', value: 0.35, type: 'feed-in' },
    { timestamp: '2025-03-05T20:00:00.000Z', value: 0.3, type: 'feed-in' },
    { timestamp: '2025-03-05T21:00:00.000Z', value: 0.2, type: 'feed-in' },

    // feed-out (grid export — solar generation peaking midday)
    { timestamp: '2025-03-04T22:00:00.000Z', value: 0, type: 'feed-out' },
    { timestamp: '2025-03-04T23:00:00.000Z', value: 0, type: 'feed-out' },
    { timestamp: '2025-03-05T00:00:00.000Z', value: 0, type: 'feed-out' },
    { timestamp: '2025-03-05T01:00:00.000Z', value: 0, type: 'feed-out' },
    { timestamp: '2025-03-05T02:00:00.000Z', value: 0, type: 'feed-out' },
    { timestamp: '2025-03-05T03:00:00.000Z', value: 0, type: 'feed-out' },
    { timestamp: '2025-03-05T04:00:00.000Z', value: 0, type: 'feed-out' },
    { timestamp: '2025-03-05T05:00:00.000Z', value: 0.02, type: 'feed-out' },
    { timestamp: '2025-03-05T06:00:00.000Z', value: 0.08, type: 'feed-out' },
    { timestamp: '2025-03-05T07:00:00.000Z', value: 0.2, type: 'feed-out' },
    { timestamp: '2025-03-05T08:00:00.000Z', value: 0.35, type: 'feed-out' },
    { timestamp: '2025-03-05T09:00:00.000Z', value: 0.5, type: 'feed-out' },
    { timestamp: '2025-03-05T10:00:00.000Z', value: 0.6, type: 'feed-out' },
    { timestamp: '2025-03-05T11:00:00.000Z', value: 0.65, type: 'feed-out' },
    { timestamp: '2025-03-05T12:00:00.000Z', value: 0.68, type: 'feed-out' },
    { timestamp: '2025-03-05T13:00:00.000Z', value: 0.65, type: 'feed-out' },
    { timestamp: '2025-03-05T14:00:00.000Z', value: 0.55, type: 'feed-out' },
    { timestamp: '2025-03-05T15:00:00.000Z', value: 0.4, type: 'feed-out' },
    { timestamp: '2025-03-05T16:00:00.000Z', value: 0.22, type: 'feed-out' },
    { timestamp: '2025-03-05T17:00:00.000Z', value: 0.08, type: 'feed-out' },
    { timestamp: '2025-03-05T18:00:00.000Z', value: 0.02, type: 'feed-out' },
    { timestamp: '2025-03-05T19:00:00.000Z', value: 0, type: 'feed-out' },
    { timestamp: '2025-03-05T20:00:00.000Z', value: 0, type: 'feed-out' },
    { timestamp: '2025-03-05T21:00:00.000Z', value: 0, type: 'feed-out' }
  ]
}
